import type * as React from "react";
import { memo, useMemo } from "react";

import type { IIconAttributes } from "@components/icons/icon";

export const IconWrapper = memo(function IconWrapper({
  icon,
  color: colorProp,
  size: sizeProp,
  autoSize,
  ...restProps
}: IIconAttributes & { icon: React.ReactNode }) {
  const color = useMemo(() => colorProp || "currentColor", [colorProp]);
  const size = useMemo(
    () => (sizeProp ? `${sizeProp / 16}rem` : "1rem"),
    [sizeProp],
  );

  return (
    <span
      role={"img"}
      aria-hidden={"true"}
      style={{
        color,
        width: size,
        height: size,
        display: "flex",
        fontSize: "inherit",
        justifyContent: "center",
        alignItems: "center",
      }}
      {...restProps}
    >
      {icon}
    </span>
  );
});
